import React from 'react';
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row, Col, FormGroup, Input, Label, Modal, Spinner, ModalBody, ModalFooter
} from "reactstrap";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import { Autocomplete } from "@autocomplete/material-ui";
import decodeJwt from 'jwt-decode';
import ModalImage from "react-modal-image";
import Locations from '../locations/location-hold';



const Notifications = (props) => {
  const history = useHistory();
  const [users, setUsers] = useState(false);
  const [locations, setLocations] = useState(false);
  const [tenants, setTenants] = useState(false);
  const [pos, setPos] = useState([]);
  const [loc, setLoc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectusers, setSelectusers] = useState([]);
  const [notifications, setNotifications] = useState(false);
  const [flag, setFlag] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [allusers, setAllusers] = useState([]);
  const [peropen, setPeropen] = useState(false)
  const [sucess, setSucess] = useState(false);
  const [notifyvilla, setNotifyvilla] = useState(false);
  const [locationarr, setLocationarr] = useState(false);
  const [locationarray, setLocationarray] = useState([]);




  const getOptions = (q) => {
    var query = new RegExp(q);
    return tenants.filter(function (o) { return query.test(o.name); });
  };

  const getLocations = (q) => {
    var query = new RegExp(q);
    let locfilter = locations.filter(function (o) { return query.test(o.location); });
    let arr = [];
    locfilter.map(item => {
      item.children.map(child => {
        // console.log(child)
        arr.push({ id: child._id, name: child.location })
        // return ();
      })
    })
    setLocationarr(arr)
    return arr;

  };


  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const removeData = (id, index) => {
    dataProvider.delete('notifications', { id: id }).then(({ data }) => {
      let notificationArr = notifications;
      notificationArr.splice(index, 1);
      setNotifications(notificationArr);
      setFlag(!flag)
      setConfirmOpen({ visible: false, id: null, index: null });
    });
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('users', { params: { pagination: { page: 1, perPage: 500 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        setUsers(data);
      })
    dataProvider.getList('tenants', { params: { pagination: { page: 1, perPage: 500 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          let newLists = data.filter(item => {
            let today = new Date()
            let contract_date = new Date('' + item.contract_ended)
            if (contract_date > today || item.contract_ended === null) { return item }
          })
          let newList = newLists.filter(item => item.status !== 0)
          var result = newList.map(tenant => ({ name: tenant.fullname, id: tenant.id }));
          setTenants(result);
          // setAllusers(results)
        }
      })
    dataProvider.getList('locations/list', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setLocations(data[0].data);
      })

    dataProvider.getList('notifications', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setNotifications(data);
      })
      .catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, [props, reload]);
  // console.log(locations);

  const onSubmit = (values) => {
    setLoading(true)
    dataProvider.createNotifications('notifications', { ...values, tenants: pos, allusers: allusers, sub_location: loc, villa_based: notifyvilla })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => Push(), 1000);
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  };
  const Push = () => {
    setSucess(false)
    window.location.reload()

  }
  // const onChangeUsers = (value, target) => {
  //   let username = target.options[target.selectedIndex].dataset.user;
  //   let isExist = selectusers.find(item => item.id === value)
  //   if (!isExist) {
  //     setSelectusers(prevState => [...prevState, { id: value, name: username}]);
  //     setPos(prevState => [...prevState, value]);
  //   }
  // }
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const onChangeUsers = (q) => {
    // console.log(q)
    if (!q || !q.id) { return; }
    let isExist = selectusers.find(item => item.id === q.id)
    if (!isExist) {
      setSelectusers(prevState => [...prevState, { id: q.id, name: q.name }]);
      setPos(prevState => [...prevState, q.id]);
    }
  }
  const onChangeLocation = (q) => {
    if (!q || !q.id) { return; }
    let isExist = locationarray.find(item => item.id === q.id)
    if (!isExist) {
      setLocationarray(prevState => [...prevState, { id: q.id, name: q.name }]);
      setLoc(prevState => [...prevState, q.id]);
    }
  }
  const usersRemove = (user) => {
    const newList = selectusers.filter(item => item.id !== user);
    const newuserList = pos.filter(item => item !== user);
    setPos(newuserList);
    setSelectusers(newList)
  }
  const locationRemove = (user) => {
    const newList = locationarray.filter(item => item.id !== user);
    const newuserList = loc.filter(item => item !== user);
    setLoc(newuserList);
    setLocationarray(newList)
  }

  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const Notifyallusers = (data) => {
    if (data === true) {
      var results = tenants.map(tenant => (tenant.id));
      setPos(results)
    }
  }
  const Notify_villa = (data) => {
    if (data === true) {
      setNotifyvilla(data)
    }
    else {
      setNotifyvilla(false)
    }

  }
  let per = localStorage.getItem('permission');

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  if (!notifications) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white' }}>NOTIFICATIONS</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--7">
        <Row className="mt-4" >
          <Col className xl="7"  >
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start', color: '#5d5d4b', fontWeight: 'bold' }}><h3>NOTIFICATIONS</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" >
                <thead className="thead-light"  >
                  <tr>
                    <th scope="col" >NOTIFICATION</th>
                    <th scope="col" >IMAGE</th>
                    <th scope="col" >ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications && notifications.length > 0 && (
                    notifications.map((item, index) => (
                      <tr>
                        <td style={{ fontWeight: 'bold' }}>{item.title}
                          <div style={{ marginTop: 5, fontSize: '0.6rem', fontWeight: 'normal' }}>{item.sub_heading}</div>
                          <div style={{ marginTop: 5, fontSize: '0.6rem', fontWeight: 'normal', maxWidth: 350, whiteSpace: 'break-spaces' }}>{item.message}</div>
                        </td>
                        <td>
                          <ModalImage
                            className='image-notificationsize'
                            // style={{ width: "50px", display: "block", margin: "auto",color:'white' }}
                            small={item?.image_path ? item?.image_path : null}
                            large={item?.image_path}
                            // alt={item?.image_path}
                            hideDownload={true}
                            hideZoom={true}
                          />
                        </td>
                        {/* <td style={{ width: '20px' }}>{item?.image_path ? <img src={item?.image_path} className="img-fluid" alt="..." /> : ''}</td> */}
                        <td style={{ flexDirection: 'row' }}>
                          {per.includes('notification_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item._id, index: index })} ><IcomoonReact iconSet={iconSet} color="#ccc" size={20} icon="delete" /> </Button> :
                            <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}  ><IcomoonReact iconSet={iconSet} color="#ccc" size={20} icon="delete" /> </Button>}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </Col>
          <Col xl="5"  >
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0" style={{ fontWeight: 'bold', color: '#5d5d4b', marginLeft: 14 }} >CREATE NOTIFICATION</h3>
                  </div>
                </Row>
              </CardHeader>
              <Form
                onSubmit={onSubmit}
                validate={values => {
                  const errors = {};
                  if (!values.title) {
                    errors.title = "Required";
                  }
                  if (!values.message) {
                    errors.message = "Required";
                  }
                  return errors;
                }}
                render={({ handleSubmit, reset, form }) => (
                  <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }}>
                            <Label style={{ fontSize: ' 0.9rem', color: '#67614e' }} for="name">Notification Title</Label>
                            <Field name="title"  >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    name="title"
                                    placeholder="Enter Notification title"
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }} >
                            <Label style={{ fontSize: ' 0.9rem', color: '#67614e' }} for="name">Sub Heading</Label>
                            <Field name="sub_heading" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    name="sub_heading"
                                    placeholder="Type"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }} >
                            <Label style={{ fontSize: ' 0.9rem', color: '#67614e' }} for="name">Message</Label>
                            <Field name="message" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', padding: 15, borderRadius: 10, overflow: 'hidden' }}
                                    type="textarea"
                                    name="message"
                                    placeholder="Type Message"
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <Label style={{ fontSize: ' 0.9rem', color: '#67614e' }}>Choose a image(optional)</Label>
                          <Field name="image">
                            {({ input: { value, onChange, ...input }, meta }) => (
                              <div style={{
                                border: 'solid',
                                borderWidth: 'thin',
                                borderRadius: '5px',
                                padding: '8px',
                                borderColor: '#ccc'
                              }} >
                                <Input
                                  {...input}
                                  name="image"
                                  accept="image/png,image/jpeg"
                                  style={{ color: 'black' }}
                                  type="file"
                                  onChange={(e) => onChange(e.target.files)}
                                />
                              </div>
                            )}
                          </Field>
                        </Col>
                        {/* <Col lg="12">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.8125rem' }} for="users">Send To:</Label>
                            <Field name="users">
                              {({ input, meta, value }) => (
                                <div>
                                  <Input required type="select" multiple={true} onChange={(e) => onChangeUsers(e.target.value, e.target)} name="users" id="users" style={{ color: 'black' }}>
                                    <option value="" style={{ color: '#ccc' }} >Selected users</option>
                                    {tenants && tenants.map((item, index) => {
                                      return (<option data-user={item.fullname} value={item.id}>{item.fullname}</option>)
                                    })}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col> */}
                        <Col lg="12" style={{ marginTop: 20 }}>
                          <FormGroup check>
                            <div>
                              <Input type="checkbox" name="notify"
                                onChange={(e) => Notify_villa(e.target.checked)}
                              />
                              <span style={{ fontSize: '13px', listStyle: 'none', color: 'black', fontWeight: 600 }}>NOTIFICATION BASED ON VILLA NO</span>
                            </div>
                          </FormGroup>
                        </Col>
                        {notifyvilla ?
                          <Col lg="12">
                            <label style={{ marginTop: 25, color: '#67614e' }}>Send To:</label>
                            <Autocomplete
                              valueToDisplay={(o) => ''}
                              style={{ border: '1px solid #ccc', marginBottom: 20, paddingTop: 15, borderRadius: 5 }}
                              onChange={q => {
                                onChangeLocation(q)
                              }}
                              //onChangeUsers
                              multiple
                              selectOnBlur
                              requireMatch
                              getOptions={getLocations}
                              getOptionLabel={(option) => option.name}
                              optionToKey={(o) => o.id}
                              optionToDisplay={options => (options.name)}
                              disableCloseOnSelect
                            />
                            <div style={{ position: 'absolute', right: 20, top: 30, marginTop: 40 }}>
                              <IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" />
                            </div>
                          </Col> :
                          <Col lg="12">
                            <label style={{ marginTop: 25, color: '#67614e' }}>Send To:</label>
                            <Autocomplete
                              valueToDisplay={(o) => ''}
                              style={{ border: '1px solid #ccc', marginBottom: 20, paddingTop: 15, borderRadius: 5 }}
                              onChange={q => {
                                onChangeUsers(q)
                              }}
                              //onChangeUsers
                              multiple
                              selectOnBlur
                              requireMatch
                              getOptions={getOptions}
                              getOptionLabel={(option) => option.name}
                              optionToKey={(o) => o.id}
                              optionToDisplay={options => (options.name)}
                              disableCloseOnSelect
                            />
                            <div style={{ position: 'absolute', right: 20, top: 30, marginTop: 40 }}>
                              <IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" />
                            </div>
                          </Col>
                        }
                        <Col lg="12">
                          {/* <label style={{ marginTop: 25 }}>Send To:</label> */}
                          <FormGroup check>
                            <div>
                              <Input type="checkbox" name="notify"
                                style={{ marginTop: 7 }}
                                onChange={(e) => Notifyallusers(e.target.checked)}
                              />
                              <span style={{ fontSize: '13px', listStyle: 'none', color: 'black', fontWeight: 600 }}>SEND TO ALL TENANTS</span>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div style={{ marginTop: 20, padding: 10, display: 'inline-block' }}>
                      {selectusers && selectusers.length > 0 && (
                        selectusers.map(user => (
                          <span style={{ border: '1px solid black', padding: 5, margin: 0, borderRadius: 20, marginLeft: 10, whiteSpace: 'nowrap', color: 'black' }}>{user.name}
                            <Button style={{ boxShadow: 'none', backgroundColor: 'transparent', borderColor: '#fff' }} onClick={() => usersRemove(user.id)}>
                              <IcomoonReact iconSet={iconSet} color="#556F71" size={12} icon="close" style={{ marginBottom: 4 }} /></Button>
                          </span>
                        ))
                      )}
                    </div>
                    <div style={{ marginTop: 20, padding: 10, display: 'inline-block' }}>
                      {locationarray && locationarray.length > 0 && (
                        locationarray.map(user => (
                          <span style={{ border: '1px solid black', padding: 5, margin: 0, borderRadius: 20, marginLeft: 10, whiteSpace: 'nowrap', color: 'black' }}>{user.name}
                            <Button style={{ boxShadow: 'none', backgroundColor: 'transparent', borderColor: '#fff' }} onClick={() => locationRemove(user.id)}>
                              <IcomoonReact iconSet={iconSet} color="#556F71" size={12} icon="close" style={{ marginBottom: 4 }} /></Button>
                          </span>
                        ))
                      )}
                    </div>
                    {per.includes('notification_add') ? <Col lg="12">
                      <div style={{ marginLeft: 10, marginTop: 20 }}>
                        <Button disabled={loading} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', borderRadius: 10, padding: 14, marginBottom: 20, border: 0, marginTop: -10 }}>
                          {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                          SUBMIT</Button>{' '}
                      </div>
                    </Col> :
                      <Col lg="12">
                        <div style={{ marginLeft: 10, marginTop: 20 }}>
                          <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', borderRadius: 10, padding: 14, marginBottom: 20, border: 0, marginTop: -10 }}>
                            SUBMIT</Button>{' '}
                        </div>
                      </Col>}
                  </form>
                )}
              />
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Notify successfully..!</ModalBody>
      </Modal>
    </>
  );
};

export default Notifications;